$(document).ready(function(){
    $("#abrirMenuPrincipal").click(function(){
        // Most effect types need no options passed by default
        var options = {};

        $( "#menuOpcoesArea" ).addClass('ativo');

        setTimeout(function (){
            $( "#menuOpcoesArea .menu-titulo").addClass('ativo');
            $( "#menuOpcoesArea ul").addClass('ativo');
        }, 300);

        /*
        $( "#menuOpcoesArea" ).show('fade');

        setTimeout(function (){
            $( "#menuOpcoesArea .menu-titulo").show('drop', options, 500, () => {} );
            $( "#menuOpcoesArea ul").show('drop', options, 500, () => {} );
        }, 500);

        setTimeout(function (){
            $( "#menuOpcoesArea ul li").removeClass('no-show');
        }, 1000);

         */
    });

    $("#fecharMenuPrincipal").click(function(){
        // Most effect types need no options passed by default
        var options = {};

        $( "#menuOpcoesArea" ).removeClass('ativo');
        $( "#menuOpcoesArea .menu-titulo").removeClass('ativo');
        $( "#menuOpcoesArea ul").removeClass('ativo');

        /*
        $( "#menuOpcoesArea" ).hide('fade', options, 500, () => {} );
        $( "#menuOpcoesArea .menu-titulo").hide('drop', options, 500, () => {} );
        $( "#menuOpcoesArea ul").hide('drop', options, 500, () => {} );
        $( "#menuOpcoesArea ul li").addClass('no-show');
         */
    });

    $('.opcao-menu').hover(function (){
        $('.detalhes-opcoes .detalhes').addClass('d-none').addClass('ativo');
        $(`.detalhes-opcoes .${$(this).attr('data-id')}`).removeClass('d-none').addClass('ativo');
    });
    /*
    $(".opcao-menu a").hover(function(){
        $(".opcao-menu .detalhes").removeClass("visible");
        $(this).siblings(".detalhes").addClass("visible");
    });

    $(".opcao-menu .detalhes").hover(function(){
        $(this).addClass("visible");
    }, function(){
        $(this).removeClass("visible");
    });
     */

    $('#formularioDenuncia').submit(function (event){
        var formulario = document.getElementById('formularioDenuncia');
        var campos = formulario.querySelectorAll('input, textarea, select');
        for (var i = 0; i < campos.length; i++) {
            // Verifica se o campo é obrigatório
            if (campos[i].hasAttribute('required')) {
                // Verifica se o campo está vazio
                if (campos[i].value.trim() === '') {
                    event.preventDefault();
                }
                // Se o campo é um campo de email, verifica se é um email válido
                if (campos[i].type === 'email') {
                    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(campos[i].value)) {
                        event.preventDefault();
                    }
                }
            }
        }

        alerta(9999999, "Aguarde!", "Estamos registrando sua denúncia.");
        return true;
    });

    $('#button-buscar').click(function (){
        alerta(9999999, "Aguarde!", "Buscando os dados da sua denúncia.");
    });

    telefoneMask();
});

function telefoneMask(){
    var behavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(behavior.apply({}, arguments), options);
            }
        };

    $('.telefone').mask(behavior, options);
}

function validarTamanhoTotal() {
    var inputFiles = document.querySelector('input[type="file"]');
    var files = inputFiles.files;
    var tamanhoTotal = 0;
    for (var i = 0; i < files.length; i++) {
        tamanhoTotal += files[i].size;
    }
    var limite = 100000000; // 1 MB
    if (tamanhoTotal > limite) {
        alert("O tamanho total dos arquivos excede o limite permitido.");
        return false;
    }
    return true;
}

function alerta(timer = 9999, titulo = '', texto = ''){
    let timerInterval;
    Swal.fire({
        title: titulo,
        html: texto,
        timer: timer,
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
        willClose: () => {
            clearInterval(timerInterval);
        }
    }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
            //console.log("I was closed by the timer");
        }
    });
}
